module.exports = __webpack_public_path__ + "media/4video.bf7f3254.mp4";